<template>
  <div>

    <el-row :gutter="15">
      <el-col :span="12">
        <!--设备-->
        <el-card style="height: calc(50vh - 60px);">
          <div slot="header" class="card-header"><i class="el-icon-font el-icon-shebeizuguanli el-icon--left"></i>设备
          </div>
          <div class="es-op-box">
            <el-input placeholder="请输入设备名称" v-model="queryObj.keyWord" size="small" class="query"
              style="float: left;width: 140px;" clearable @change="() => { this.queryObj.pageNum = 1; loadAssetList() }">
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-input placeholder="请输入所属部门" v-model="queryObj.orgName" size="small" class="query"
              style="float: left;width: 140px;" clearable @change="() => { this.queryObj.pageNum = 1; loadAssetList() }">
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-input placeholder="请输入厂家" v-model="queryObj.manufacturerName" size="small" class="query"
              style="float: left;width: 120px;" clearable @change="() => { this.queryObj.pageNum = 1; loadAssetList() }">
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-select style="float: left;margin-bottom: 10px;width: 150px;" class="query" size="small"
              v-model="queryObj.typeId" placeholder="请选择设备类型" clearable filterable
              @clear="() => { this.queryObj.pageNum = 1; delete this.queryObj.typeId; loadAssetList() }"
              @change="() => { this.queryObj.pageNum = 1; loadAssetList() }">
              <el-option v-for="item in types" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>

            <el-tag style="float: left;margin-bottom: 10px;">总额占比%</el-tag>
            <el-input v-model="queryObj.ratePrice" type='number' size="small" min="1" max="100" class="query"
              style="float: left;width: 70px;" @blur="() => { this.queryObj.pageNum = 1; this.loadAssetList() }">
            </el-input>
            <el-button type="primary" size="mini" style="margin-right:6px" :loading="loadingDownloadAsset"
              @click="downloadAsset()"><i class="el-icon-download" style="font-size: 14px;"></i><span
                style="margin-left: 5px;">设备</span></el-button>
            <br />
          </div>
          <el-table :data="pageData.list" ref="deviceTable" border stripe size="mini" height="calc(50vh - 200px)"
            highlight-current-row @current-change="handleCurrentChange" v-loading="loading">
            <el-table-column type="index" label="序号" width="50" align="center">
            </el-table-column>
            <el-table-column prop="orgName" label="所属部门"> </el-table-column>
            <el-table-column prop="name" label="设备名称"> </el-table-column>
            <el-table-column prop="typeName" label="设备类型">
            </el-table-column>
            <el-table-column prop="assetPrice" label="资产总额">
            </el-table-column>

            <el-table-column prop="matPrice" label="投入材料金额">
              <template slot-scope="scope">
                <el-link type="primary" @click="viewMat(scope.row)">{{ scope.row.matPrice }}</el-link>
              </template>
            </el-table-column>

            <el-table-column prop="rate" label="总额占比">
            </el-table-column>
          </el-table>
          <div class="es-page-box">
            <es-pagination :data="pageData" @change="(cpage) => { this.queryObj.pageNum = cpage; this.loadAssetList() }">
            </es-pagination>
          </div>
        </el-card>
      </el-col>

      <el-col :span="12">
        <!--设备详情-->
        <el-card style="height: calc(50vh - 60px);">
          <div slot="header" class="card-header"><i class="el-icon-menu"></i>详情 <span v-if="currentRow != null">
              [{{ currentRow.name }}]</span></div>
          <div class="es-op-box">
            <el-date-picker style="float: left;width:300px;margin-bottom: 10px;" value-format="yyyy-MM-dd"
              v-model="dateTime" type="daterange" size="small" class="query" range-separator="至"
              start-placeholder="计划开始日期起始" end-placeholder="计划开始日期结束" clearable @clear="() => { this.dateTime = []; }"
              @change="() => {
                  this.queryHisObj.pageNum = 1;
                  loadAssetHis()
                }">
            </el-date-picker>
            <el-radio-group v-model="queryHisObj.busstype" style="float: left" size="small" @change="() => {
                this.queryHisObj.pageNum = 1;
                loadAssetHis()
              }">
              <el-radio-button label="fault">故障</el-radio-button>
              <el-radio-button label="ins">巡检</el-radio-button>
              <el-radio-button label="main">保养</el-radio-button>
            </el-radio-group>
            <el-button type="primary" size="mini" style="margin-right:6px" :loading="loadingDownload"
              @click="downloadAssetById()"><i class="el-icon-download" style="font-size: 14px;"></i><span
                style="margin-left: 5px;">履历</span></el-button>
          </div>
          <el-table v-if="queryHisObj.busstype == 'fault'" :data="pageHisData.list" ref="hisTable" border stripe
            size="mini" height="calc(50vh - 200px)" v-loading="loadingHis">
            <el-table-column type="index" label="序号" width="50" align="center">
            </el-table-column>
            <el-table-column width="150px" label=" 故障发生时间" align="center">
              <template slot-scope="scope">
                {{ scope.row.occu_time.replace("T", " ") }}
              </template>
            </el-table-column>
            <el-table-column prop="appe_name" label="故障现象" align="center">
            </el-table-column>
            <el-table-column prop="solution_name" label="解决方案" align="center">
            </el-table-column>

            <el-table-column prop="resolver_name" label="解决人" align="center">
            </el-table-column>
            <el-table-column width="150px" label="解决时间" align="center">
              <template slot-scope="scope">
                {{ scope.row.solve_time.replace("T", " ") }}
              </template>
            </el-table-column>

            <el-table-column label="操作" width="50" align="center">
              <template slot-scope="scope">
                <el-link :underline="false" title="详情" @click="viewFauDetail(scope.row)" type="success"><i
                    class="el-icon-font el-icon-view"></i></el-link>
              </template>
            </el-table-column>

          </el-table>
          <el-table v-if="queryHisObj.busstype == 'ins'" :data="pageHisData.list" ref="hisTable" border stripe size="mini"
            height="calc(50vh - 200px)" v-loading="loadingHis">
            <el-table-column type="index" label="序号" width="50" align="center">
            </el-table-column>
            <el-table-column width="150px" label=" 完成时间" align="center">
              <template slot-scope="scope">
                {{ scope.row.finish_time.replace("T", " ") }}
              </template>
            </el-table-column>
            <el-table-column prop="inspeople_name" label="巡检人" align="center">
            </el-table-column>
            <el-table-column prop="line_name" label="线路名称" align="center">
            </el-table-column>
          </el-table>
          <el-table v-if="queryHisObj.busstype == 'main'" :data="pageHisData.list" ref="hisTable" border stripe
            size="mini" height="calc(50vh - 200px)" v-loading="loadingHis">
            <el-table-column type="index" label="序号" width="50" align="center">
            </el-table-column>
            <el-table-column width="150px" label=" 完成时间" align="center">
              <template slot-scope="scope">
                {{ scope.row.done_time.replace("T", " ") }}
              </template>
            </el-table-column>
            <el-table-column prop="charge_person_name" label="保养人" align="center">
            </el-table-column>
            <el-table-column prop="name" label="保养名称" align="center">
            </el-table-column>
          </el-table>
          <div class="es-page-box">
            <es-pagination :data="pageHisData"
              @change="(cpage) => { this.queryHisObj.pageNum = cpage; this.loadAssetHis(this.selectorgId) }">
            </es-pagination>
          </div>
        </el-card>

      </el-col>
    </el-row>

    <el-row :gutter="15">
      <el-col :span="12">
        <!--设备故障频率-->
        <el-card id="dapartAsserts" style="height: calc(50vh - 65px);margin-top: 10px;">

          <div slot="header" class="card-header"><i class="el-icon-font el-icon-shebeizuguanli el-icon--left"></i>设备故障频率
          </div>

          <div class="es-op-box">
            <el-date-picker style="float: left;width:220px;margin-bottom: 10px;" value-format="yyyy-MM-dd"
              v-model="dateTimeFauFreq" type="daterange" size="small" class="query" range-separator="至"
              start-placeholder="故障日期起始" end-placeholder="故障日期结束" @change="() => {
                  this.queryObjFauFreq.pageNum = 1;
                  this.loadFauFreqList()
                }">
            </el-date-picker>
            <el-select style="float: left;margin-bottom: 10px;width:150px;" class="query" size="small"
              v-model="queryObjFauFreq.typeId" placeholder="请选择设备类型" clearable filterable
              @clear="() => { this.queryObjFauFreq.pageNum = 1; delete this.queryObjFauFreq.typeId }"
              @change="() => { this.queryObjFauFreq.pageNum = 1; loadFauFreqList() }">

              <el-option v-for="item in typesFauFreq" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
            <el-select style="float: left;margin-bottom: 10px;width: 120px;" class="query" size="small"
              v-model="queryObjFauFreq.workAreaId" placeholder="请选择工区" filterable
              @clear="() => { this.queryObjFauFreq.pageNum = 1 }"
              @change="() => { this.queryObjFauFreq.pageNum = 1; loadFauFreqList() }">
              <el-option v-for="item in workAreas" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>

            <el-tag style="float: left;margin-bottom: 10px;">故障次数</el-tag>
            <el-input v-model="queryObjFauFreq.fauNum" type='number' size="small" min="1" max="50" class="query"
              style="float: left;width: 70px;" @blur="() => { this.queryObjFauFreq.pageNum = 1; this.loadFauFreqList() }">

            </el-input>

            <br />
          </div>

          <el-col :span="20">
            <el-table :data="pageFauFreqData.list" ref="FauFreqTable" border stripe size="mini"
              height="calc(50vh - 200px)" v-loading="loadingFauFreq">
              <el-table-column type="index" label="序号" width="50" align="center">
              </el-table-column>
              <el-table-column prop="name" label="设备名称"> </el-table-column>
              <el-table-column prop="typeName" label="设备类型">
              </el-table-column>
              <el-table-column prop="orgName" label="组织">
              </el-table-column>
              <el-table-column prop="fauNum" label="故障次数">
              </el-table-column>
            </el-table>
            <div class="es-page-box">
              <es-pagination :data="pageFauFreqData"
                @change="(cpage) => { this.queryObjFauFreq.pageNum = cpage; this.loadFauFreqList() }">
              </es-pagination>
            </div>

          </el-col>

          <el-col :span="4">
            <el-row>
              <div>
                <el-row class="context-value">
                  {{ fauAssetAreaRate }}
                </el-row>
                <el-row class="context-key">
                  本区故障设备占比
                </el-row>
              </div>
            </el-row>
            <el-row>
              <div>
                <el-row class="context-value">
                  {{ fauAssetAllRate }}
                </el-row>
                <el-row class="context-key">
                  全区故障设备占比
                </el-row>
              </div>
            </el-row>
          </el-col>

        </el-card>
      </el-col>

      <el-col :span="12">
        <!--重点保障设备-->
        <el-card id="dapartAsserts1" style="height: calc(50vh - 65px);margin-top: 10px;">
          <div slot="header" class="card-header"><i class="el-icon-font el-icon-shebeizuguanli el-icon--left"></i>重点保障设备
          </div>

          <div class="es-op-box">
            <el-tag style="float: left;margin-bottom: 10px;">重点年限</el-tag>
            <el-input v-model="queryObjAssetImpo.impoAge" type='number' size="small" min="1" max="50" class="query"
              style="float: left;width: 70px;"
              @blur="() => { this.queryObjAssetImpo.pageNum = 1; this.loadAssetImpoList() }">
            </el-input>

            <br />
          </div>
          <el-table :data="pageAssetImpoData.list" ref="assetImpoTable" border stripe size="mini"
            height="calc(50vh - 200px)" v-loading="loadingAssetImpo">
            <el-table-column type="index" label="序号" width="50" align="center">
            </el-table-column>
            <el-table-column prop="name" label="设备名称" width="150"> </el-table-column>
            <el-table-column prop="typeName" label="设备类型">
            </el-table-column>
            <el-table-column prop="orgName" label="组织">
            </el-table-column>
            <el-table-column prop="isImportant" label="是否标记重点">
              <template slot-scope="scope">
                <font v-if="scope.row.isImportant == 0">否</font>
                <font v-if="scope.row.isImportant == 1" style="color:red">是</font>
              </template>
            </el-table-column>

            <el-table-column prop="assetAge" label="设备年龄">
            </el-table-column>

          </el-table>
          <div class="es-page-box">
            <es-pagination :data="pageAssetImpoData"
              @change="(cpage) => { this.queryObjAssetImpo.pageNum = cpage; this.loadAssetImpoList() }">
            </es-pagination>
          </div>

        </el-card>
      </el-col>

    </el-row>

    <!--材料投入详情-->
    <el-dialog :visible.sync="matListVisible" @closed="() => this.matListVisible = false" width="1000px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>消耗材料列表
      </span>
      <el-form size="mini" label-position="right" label-width="150px" ref="workForm">

        <el-table :data="this.matData" ref="matTable" border highlight-current-row stripe size="mini" height="60vh">

          <el-table-column type="index" label="序号" width="50" align="center">
          </el-table-column>

          <el-table-column prop="matTypeName" label="材料类型">
          </el-table-column>
          <el-table-column prop="matModelName" label="材料型号">
          </el-table-column>
          <el-table-column prop="quantity" label="数量">
          </el-table-column>
          <el-table-column prop="price" label="价格">
          </el-table-column>
          <el-table-column prop="createTime" label="消耗时间">
          </el-table-column>

        </el-table>

      </el-form>
    </el-dialog>

    <!--查看故障详情-->
    <el-dialog :visible.sync="viewVisible" width="1200px" style="padding-top: 0px;">

      <span slot="title">
        <i class="el-icon-font el-icon-view el-icon--left"></i>故障详情
      </span>
      <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick">
        <el-tab-pane label="上报信息" name="first">
          <div v-loading="viewLoading">
            <el-form :inline="true" size="mini" label-position="right" label-width="150px">

              <el-form-item label="故障单号">
                <el-input v-model="faultInfo.code" readonly style="width:200px">
                </el-input>
              </el-form-item>
              <el-form-item label="所属组织">
                <el-input v-model="faultInfo.orgName" readonly style="width:200px">
                </el-input>
              </el-form-item>
              <el-form-item label="所属区域">
                <el-input v-model="faultInfo.areaName" readonly style="width:200px">
                </el-input>
              </el-form-item>
              <el-form-item label="所属系统">
                <el-input v-model="faultInfo.systemName" readonly style="width:200px">
                </el-input>
              </el-form-item>
              <el-form-item label="设备类型">
                <el-input v-model="faultInfo.equiTypeName" readonly style="width:200px">
                </el-input>
              </el-form-item>
              <el-form-item label="设备型号">
                <el-input v-model="faultInfo.equiModelName" readonly style="width:200px">
                </el-input>
              </el-form-item>
              <el-form-item label="设备名称">
                <el-input v-model="faultInfo.equiName" readonly style="width:200px">
                </el-input>
              </el-form-item>
              <el-form-item label="设备模块">
                <el-input v-model="faultInfo.equiModuleName" readonly style="width:200px">
                </el-input>
              </el-form-item>
              <el-form-item label="上报时间">
                <el-input v-model="faultInfo.occuTime" readonly style="width:200px">
                </el-input>
              </el-form-item>
              <el-form-item label="上报人">
                <el-input v-model="faultInfo.reporteName" readonly style="width:200px">
                </el-input>
              </el-form-item>
              <el-form-item label="规定解决时长">
                <el-input :value="faultInfo.duration + '小时'" readonly style="width:200px">
                </el-input>
              </el-form-item>
              <el-form-item label="规定解决时间">
                <el-input v-model="faultInfo.planSolveTime" readonly style="width:200px">
                </el-input>
              </el-form-item>
              <el-form-item label="故障等级">
                <el-input v-model="faultInfo.levelName" readonly style="width:200px">
                </el-input>
              </el-form-item>
              <el-form-item label="故障现象">
                <el-input v-model="faultInfo.appeName" readonly style="width:200px">
                </el-input>
              </el-form-item>
              <el-form-item label="故障描述">
                <el-input v-model="faultInfo.des" type="textarea" :rows="2" readonly style="width:200px">
                </el-input>
              </el-form-item>
              <el-form-item label="是否专工">
                <el-input :value=isProfFormat(faultInfo) readonly style="width:200px">
                </el-input>
              </el-form-item>
              <el-form-item label="是否曾经激活">
                <el-input :value=isActivedFormat(faultInfo) readonly style="width:200px">
                </el-input>
              </el-form-item>
              <el-form-item label="来源">
                <el-input :value=sourceFormat(faultInfo) readonly style="width:200px">
                </el-input>
              </el-form-item>

              <es-img :info="faultInfo" :fileList="fileListView" type="view"></es-img>
              <!-- 扩展属性 -->
              <es-extend :extendData="extendDataReport" type="view"></es-extend>

            </el-form>
          </div>
        </el-tab-pane>

        <el-tab-pane label="解决信息" name="second">
          <div v-loading="viewLoading">
            <el-form :inline="true" size="mini" label-position="right" label-width="150px">

              <el-form-item label="解决时间">
                <el-input v-model="faultInfo.solveTime" readonly style="width:200px">
                </el-input>
              </el-form-item>
              <el-form-item label="解决人">
                <el-input v-model="faultInfo.resolverName" readonly style="width:200px">
                </el-input>
              </el-form-item>
              <el-form-item label="协作人员">
                <el-input v-model="faultInfo.companionName" readonly style="width:200px">
                </el-input>
              </el-form-item>
              <el-form-item label="解决方法">
                <el-input v-model="faultInfo.solutionName" readonly style="width:200px">
                </el-input>
              </el-form-item>
              <el-form-item label="解决方法描述">
                <el-input v-model="faultInfo.solutionDes" type="textarea" :rows="2" readonly style="width:200px">
                </el-input>
              </el-form-item>
              <el-form-item label="解决措施">
                <el-input v-model="faultInfo.measures" type="textarea" :rows="2" readonly style="width:200px">
                </el-input>
              </el-form-item>
              <el-form-item label="当前状态">
                <el-input :value="stateFormat(faultInfo, 2)" readonly style="width:200px">
                </el-input>
              </el-form-item>
              <es-img :info="faultInfo" :fileList="fileListViewHandle" type="view"></es-img>
              <!-- 扩展属性 -->
              <es-extend :extendData="extendDataSolve" type="view"></es-extend>

            </el-form>
          </div>
        </el-tab-pane>

        <el-tab-pane label="材料消耗" name="third">
          <el-table :data="matConsume" ref="matConsumeTable" show-overflow-tooltip border stripe size="mini"
            height="calc(70vh - 250px)" v-loading="loading">

            <el-table-column type="index" label="序号" width="50" align="center">
            </el-table-column>
            <el-table-column prop="matTypeName" label="材料类型">
            </el-table-column>
            <el-table-column prop="matModelName" label="材料型号">
            </el-table-column>
            <el-table-column prop="unit" label="单位">
            </el-table-column>
            <el-table-column prop="quantity" label="数量">
            </el-table-column>
            <el-table-column prop="matNumber" label="材料序列号">
            </el-table-column>

          </el-table>
        </el-tab-pane>

        <el-tab-pane label="处理过程" name="fourth">

          <el-row :gutter="20">
            <el-col :span="6">
              <div>&nbsp;</div>
            </el-col>
            <el-col :span="16">
              <div class="block" v-loading="viewLoading">
                <el-timeline>
                  <el-timeline-item v-for="(activity, index) in activities" :key="index" :icon="activity.icon"
                    :type="activity.type" :color="activity.color" :size="activity.size" :timestamp="activity.timestamp">
                    {{ activity.content }}
                  </el-timeline-item>
                </el-timeline>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>

      </el-tabs>

    </el-dialog>

  </div>
</template>
<script>
import dateutils from '../../utils/dateutils.js'
export default {
  name: 'assetstatistic',
  data () {
    return {

      systems: [],//系统专业下拉，
      types: [],//设备类型下拉，
      typesFauFreq: [],//设备类型下拉，用于设备故障频率
      workAreas: [],//工区下拉

      assetNum: [],//本区设备数和全区设备数
      fauAssetAreaRate: '0.00%',//本区故障设备占比
      fauAssetAllRate: '0.00%',//全区故障设备占比
      queryDownloadObj: {},
      queryObj: { pageNum: 1, pageSize: 20, ratePrice: 0 },//查询条件，设备   
      queryObjAssetImpo: { pageNum: 1, pageSize: 20, impoAge: 1 },//查询条件，重点设备保障 
      queryObjFauFreq: { pageNum: 1, pageSize: 20, fauNum: 1 },//查询条件，设备故障频率 
      pageData: {},
      pageFauFreqData: {},
      pageAssetImpoData: {},
      matData: [],
      matListVisible: false,
      loading: false,
      loadingAssetImpo: false,
      loadingFauFreq: false,
      //故障详情
      faultInfo: {}, //故障信息
      fauProcess: {}, //故障处理过程信息
      activeName: 'first',
      extendDataReport: [],//上报信息的扩展信息
      extendDataSolve: [],//解決信息的扩展信息
      viewVisible: false,
      viewLoading: false,
      fileListView: [],
      fileListViewHandle: [],
      loadingDownload: false,
      loadingDownloadAsset: false,
      //设备历史
      dateTime: [],
      dateTimeFauFreq: [],
      busstype: "fault",
      queryHisObj: { pageNum: 1, pageSize: 20, starttime: "", endtime: "", busstype: 'fault', id: 0 },//查询条件
      pageHisData: {},
      currentRow: null,
      loadingHis: false,
    }
  },
  methods: {
    //页面初始化
    init () {
      this.dateTime = [dateutils.dateFormat("YYYY-mm-01 00:00:01", new Date()), dateutils.dateFormat("YYYY-mm-dd 23:59:59", new Date())]
      this.dateTimeFauFreq = [dateutils.dateFormat("YYYY-mm-01 00:00:01", new Date()), dateutils.dateFormat("YYYY-mm-dd 23:59:59", new Date())]

      this.loadSystemListAll()//下拉系统专业
      this.loadTypeListAll()//下拉设备类型
      this.loadWorkAreaListAll()//下拉工区

    this.loadAssetList()//加载设备列表
      this.loadFauFreqList()//加载设备故障频率列表
      this.loadAssetImpoList()//加载重点维保设备列表

    },

    tableRowClassName ({ row }) {//改变某行的背景色
      if (row.matPrice == 0) {
        return "freeze";
      }
    },

    //初始化系统下拉框
    loadSystemListAll () {
      this.$ajax.get('/base/system/list_all').then((msg) => {
        this.systems = msg
      }).catch(err => {
        this.$message.error(err)
      })
    },

    //初始化设备类型下拉框
    loadTypeListAll () {
      this.$ajax.get('/base/assettype/list_all').then((msg) => {
        this.types = msg
        this.typesFauFreq = msg
      }).catch(err => {
        this.$message.error(err)
      })
    },

    //初始化工区下拉框
    loadWorkAreaListAll () {
      this.$ajax.get('/base/org/list_workareas').then((msg) => {
        this.workAreas = msg
        console.log(this.workAreas)
        this.queryObjFauFreq.workAreaId = this.workAreas[0].id

      }).catch(err => {
        
        this.$message.error(err)
      })
    },

    //从后台查询设备列表
    loadAssetList () {
      this.loading = true
      this.currentRow = null,

        this.$ajax.get('/buss/statistic/assetlist', this.queryObj).then((msg) => {

          this.pageData = msg

          if (this.pageData.list != null && this.pageData.list.length > 0) {
            this.setCurrent(this.pageData.list[0])
          }
          this.loading = false
        }).catch(err => {
          this.$message.error(err)
          this.loading = false
        })
    },

    //查看材料投入详情
    viewMat (row) {

      this.matListVisible = true
      this.loading = true

      this.$ajax.get('/buss/statistic/matlist', { assetId: row.id }).then((msg) => {

        this.matData = msg

        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })

    },

    //查看故障详情
    viewFauDetail (row) {

      this.viewVisible = true
      this.viewLoading = true
      this.fileListView = []
      this.fileListViewHandle = []
      this.activeName = "first"
      this.$ajax.get('/buss/fault/load_detail', { id: row.id }).then((msg) => {
        //初始化图片
        if (msg.attachImgs != null && msg.attachImgs != '') {
          let temp = JSON.parse(msg.attachImgs)
          temp.forEach(e => {
            this.fileListView.push(this.$api + e.url + '&platform=web&token=' + this.$store.getUser().token)
          })
        }
        if (msg.handleImgs != null && msg.handleImgs != '') {
          let temp = JSON.parse(msg.handleImgs)
          temp.forEach(e => {
            this.fileListViewHandle.push(this.$api + e.url + '&platform=web&token=' + this.$store.getUser().token)
          })
        }

        this.faultInfo = msg
        console.log("faultInfo", this.faultInfo)
        //加载解決扩展属性
        this.$ajax.get('/buss/fault/extend_data', {
          fauId: this.faultInfo.id, typeId: 1
        }).then((msg) => {
          this.extendDataReport = msg

        }).catch(err => {
          this.$message.error(err)
        })

        //加载解決扩展属性
        this.$ajax.get('/buss/fault/extend_data', {
          fauId: this.faultInfo.id, typeId: 2
        }).then((msg) => {
          this.extendDataSolve = msg

        }).catch(err => {
          this.$message.error(err)
        }).finally(() => {
          this.viewLoading = false
        })

      }).catch(err => {
        this.$message.error(err)
        this.viewVisible = false
        this.viewLoading = false
      })
    },


    //从后台查询设备故障频率列表
    loadFauFreqList () {

      this.loadingFauFreq = true

      if (this.dateTimeFauFreq != null && this.dateTimeFauFreq.length == 2) {
        this.queryObjFauFreq.starttime = this.dateTimeFauFreq[0]
        this.queryObjFauFreq.endtime = this.dateTimeFauFreq[1]
      }
      else {
        this.queryObjFauFreq.starttime = null
        this.queryObjFauFreq.endtime = null
      }

      this.$ajax.get('/buss/statistic/faufreqlist', this.queryObjFauFreq).then((msg) => {

        this.pageFauFreqData = msg
        this.loadingFauFreq = false
      }).catch(err => {
        
        this.$message.error(err)
        this.loadingFauFreq = false
      })

      setTimeout(() => {//延迟加载，等待上个后台调用返回数据
        //从后台获取本区设备数和全区设备数，并计算本区故障设备占比，全区故障设备占比
        this.$ajax.get('/buss/statistic/assetnumlist', this.queryObjFauFreq).then((msg) => {
          this.assetNum = msg

          this.fauAssetAreaRate =this.assetNum[0].assetNum==0?0+ "%":Math.round(this.pageFauFreqData.total / this.assetNum[0].assetNum * 10000) / 100.00 + "%"
          this.fauAssetAllRate = this.assetNum[1].assetNum==0?0+ "%":Math.round(this.pageFauFreqData.total / this.assetNum[1].assetNum * 10000) / 100.00 + "%"

        }).catch(err => {
          
          this.$message.error(err)
        })
      }, 1000);


    },

    //从后台查询重点保障设备列表
    loadAssetImpoList () {

      this.loadingAssetImpo = true
      this.$ajax.get('/buss/statistic/assetimpolist', this.queryObjAssetImpo).then((msg) => {

        this.pageAssetImpoData = msg

        this.loadingAssetImpo = false
      }).catch(err => {
        this.$message.error(err)
        this.loadingAssetImpo = false
      })
    },

    isProfFormat (row) {
      if (row.isProf == 0) {
        return '否'
      } else {
        return '是'
      }
    },
    isActivedFormat (row) {
      if (row.isActived == 0) {
        return '否'
      } else {
        return '是'
      }
    },
    sourceFormat (row) {
      if (row.source == 1) {
        return '手机端'
      } else {
        return 'WEB端'
      }
    },

    //显示状态，type=1列表用，type=2详情用
    stateFormat (row, type) {
      if (row.state == 1) {
        if (type == 1) {
          row.statename = "待分配"
          return "warning"
        }
        return "待分配"
      } else if (row.state == 2) {
        if (type == 1) {
          row.statename = "待解决"
          return "primary"
        }
        return "待解决"
      } else {
        if (type == 1) {
          row.statename = "已解决"
          return "success"
        }
        return "已解决"
      }

    },

    handleTabClick (tab) {

      if (tab.name == "fourth") {
        this.viewLoading = true
        this.activities = []
        this.$ajax.get('/buss/fault/list_fau_process', { fauId: this.faultInfo.id }).then((msg) => {
          msg.forEach((ele) => {
            this.fauProcess = {}
            this.fauProcess.content = (ele.senderName == null ? '' : ele.senderName) + '【' + (ele.des == null ? '' : ele.des) + '】' + (ele.receiverName == null ? '' : ele.receiverName)
            this.fauProcess.timestamp = ele.createTime
            this.fauProcess.color = '#0bbd87'
            this.fauProcess.icon = 'el-icon-star-on'
            this.activities.push(this.fauProcess)

          })


        }).finally(() => {
          this.viewLoading = false
        }).catch(err => {
          this.$message.error(err)
          this.viewLoading = false
        })

      }

      if (tab.name == "third") {
        this.viewLoading = true
        this.matConsume = []
        this.$ajax.get('/buss/fault/list_mat_consume', { fauId: this.faultInfo.id }).then((msg) => {

          this.matConsume = msg

        }).finally(() => {
          this.viewLoading = false
        }).catch(err => {
          this.$message.error(err)
          this.viewLoading = false
        })

      }

    },

    setCurrent (row) {
      this.currentRow = row;
      if (row != null) {
        this.$refs.deviceTable.setCurrentRow(row)
        this.loadAssetHis()
      }
    },

    handleCurrentChange (val) {
      this.currentRow = val;
      this.loadAssetHis();
    },
    downloadAssetById () {
      if (this.currentRow == null) {
        return
      }
      this.queryDownloadObj.id = this.currentRow.id
      this.loadingDownload = true
      if (this.dateTime != null && this.dateTime.length == 2) {
        this.queryDownloadObj.starttime = this.dateTime[0]
        this.queryDownloadObj.endtime = this.dateTime[1]
      }
      else {
        this.queryDownloadObj.starttime = null
        this.queryDownloadObj.endtime = null
      }
      let url = '/buss/report/downloadAssetById'
      this.$ajax.downFile(url, this.queryDownloadObj).then((msg) => {
        this.$message.success(msg)
        this.loadingDownload = false
      }).catch(err => {
        this.$message.error(err)
        this.loadingDownload = false
      })
    },
    downloadAsset () {
      this.loadingDownloadAsset = true
      let url = '/buss/report/downloadAsset'
      this.$ajax.downFile(url, this.queryObj).then((msg) => {
        this.$message.success(msg)
        this.loadingDownloadAsset = false
      }).catch(err => {
        this.$message.error(err)
        this.loadingDownloadAsset = false
      })
    },
    loadAssetHis () {
      if (this.currentRow == null) {
        return
      }

      this.queryHisObj.id = this.currentRow.id
      this.loadingHis = true
      if (this.dateTime != null && this.dateTime.length == 2) {
        this.queryHisObj.starttime = this.dateTime[0]
        this.queryHisObj.endtime = this.dateTime[1]
      }
      else {
        this.queryHisObj.starttime = null
        this.queryHisObj.endtime = null
      }

      this.$ajax.get('/buss/statistic/asserthislist', this.queryHisObj).then(msg => {
        this.pageHisData = msg
        this.loadingHis = false
      }).catch(err => {
        this.$message.error(err)
        this.loadingHis = false
      })
    },

  },
  mounted () {
    this.init()
  }
}
</script>
<style>
.cbottom {
  width: 100%;
  height: 260px;
}

.context-value {
  color: rgb(68, 67, 67);
  font-size: 30px;
  margin-top: 25px;
  text-align: center;
}

.context-key {
  color: rgb(126, 125, 125);
  font-size: 12px;
  margin-top: 5px;
  text-align: center;
}

/* 改变表格整行的背景色 */
.el-table.freeze {
  background: #F5A623;
}
</style>
